"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepayRecordDetailRequest = void 0;
var RepayRecordDetailRequest = /** @class */ (function () {
    function RepayRecordDetailRequest() {
        this.repayApplyNo = '';
    }
    return RepayRecordDetailRequest;
}());
exports.RepayRecordDetailRequest = RepayRecordDetailRequest;
//# sourceMappingURL=repayRecordDetail.request.js.map